import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import http from "../Http/Http";
import "../App/App.css";
import "./Search.css";
import "./icon-search.svg";

class Search extends Component {
  constructor() {
    super();

    this.state = {
      query: "",
      results: [],
      isInvalid: false,
      isSubmitting: false,
      isSubmitted: false,
      isLoaded: false
    };

    this.clear = this.clear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.search = this.search.bind(this);
  }

  clear() {
    this.setState({ query: "" });
    this.searchInput.focus();
  }

  validateForm(onValidForm) {
    const isInvalid = this.state.query.length === 0;

    this.setState({ isInvalid });

    // invoke callback function when code is valid
    if (onValidForm && !isInvalid) {
      onValidForm();
    }
  }

  handleChange(event) {
    this.setState(
      {
        query: event.target.value
      },
      () => {
        if (this.state.isSubmitted) {
          this.validateForm();
        }
      }
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ isSubmitted: true });
    this.validateForm(this.search);
  }

  search() {
    this.setState({ isSubmitting: true });

    let phoneNumber;
    const { query } = this.state;
    const results = [];
    const sourcePhoneNumber = localStorage.getItem("phoneNumber");

    if (query !== sourcePhoneNumber) {
      http
        .get(`/wallet/$${query}`)
        .then(response => {
          // get phone number from wallet handle
          phoneNumber = response.data.handle.substring(1);

          // get the default signer from the response
          const signerId = response.data.default;

          if (signerId) {
            return signerId;
          } else {
            throw Error("No default signer");
          }
        })
        .then(signerId => {
          return http.get(`/signer/${signerId}`);
        })
        .then(response => {
          const name = response.data.labels.firstName;

          if (name) {
            results.push({ name, email: phoneNumber });
            this.setState({ isSubmitting: false, isLoaded: true, results });
          } else {
            throw Error("No name configured for this signer");
          }
        })
        .catch(() => {
          this.setState({ isSubmitting: false, isLoaded: true });
        });
    } else {
      this.setState({ isSubmitting: false, isLoaded: true });
    }
  }

  resultItem({ name, email }, key) {
    return (
      <li className="search-results-item" key={key}>
        <Link to={`/transferir/${email}`}>
          <div className="search-results-item-name">{name}</div>
          <div className="search-results-item-tag">+{email}</div>
        </Link>
      </li>
    );
  }

  render() {
    const { query, results, isInvalid, isSubmitting, isLoaded } = this.state;

    return (
      <div className="search">
        <h1 className="search-title">A quien quieres transferir?</h1>
        <p className="search-intro">
          Ingrese el nombre o número de teléfono de la persona a quien quieres
          transferir:
        </p>
        <form
          className="search-form"
          action=""
          onSubmit={this.handleSubmit}
          noValidate
        >
          <div className="search-input-container">
            <input
              className="search-input"
              type="text"
              maxLength="50"
              value={query}
              onChange={this.handleChange}
              ref={input => {
                this.searchInput = input;
              }}
              aria-invalid={isInvalid}
              autoComplete="off"
            />
            {query && (
              <button
                className="search-clear"
                type="reset"
                onClick={this.clear}
              >
                <span className="search-clear-label">Borrar búsqueda</span>
              </button>
            )}
          </div>
          <button
            className="search-submit button-green"
            disabled={isSubmitting}
          >
            <span className="search-button-label">Buscar</span>
          </button>
        </form>
        {isInvalid && (
          <div className="search-error" aria-live="polite">
            Ingrese un nombre o número de teléfono
          </div>
        )}
        {isLoaded &&
          !isSubmitting &&
          results.length === 0 && <p>No hay resultados.</p>}
        {isLoaded &&
          !isSubmitting &&
          results.length > 0 && (
            <ul className="search-results-list">
              {results.map((item, index) => this.resultItem(item, index))}
            </ul>
          )}
      </div>
    );
  }
}

Search.contextTypes = {
  isSignedIn: PropTypes.bool
};

export default Search;



// WEBPACK FOOTER //
// ./src/Search/Search.js